export const ChainIds = {
  TEZOS: "tezos",
  ETHERLINK: "etherlink",
  ETHEREUM: "ethereum",
  BITCOIN: "bitcoin",
  BSC: "bsc",
} as const;

export const ChainNamespaces = {
  EVM: "eip155",
  TEZOS: "tezos",
  BITCOIN: "bitcoin",
} as const;

export const TransactionDirections = {
  SEND: "send",
  RECEIVE: "receive",
} as const;

export const OperationTypes = {
  TRANSACTION: "transaction",
  TOKEN_TRANSFER: "token_transfer",
  CONTRACT_CALL: "contract_call",
  TOKEN_MINTING: "token_minting",
  SAFE_SEND: "safe_send",
  TOKEN_BURNING: "token_burning",
  SHIELD: "shield",
  UNSHIELD: "unshield",
  SAPLING: "sapling",
} as const;

export const CryptoSymbols = {
  [ChainIds.TEZOS]: "XTZ",
  [ChainIds.ETHERLINK]: "XTZ",
  [ChainIds.ETHEREUM]: "ETH",
  [ChainIds.BSC]: "BNB",
  [ChainIds.BITCOIN]: "BTC",
} as const;

export type ChainId = (typeof ChainIds)[keyof typeof ChainIds];
export type ChainNamespace = (typeof ChainNamespaces)[keyof typeof ChainNamespaces];
export type ChainFullId = `${ChainNamespace}:${string}`;

export type MultichainChainId = Exclude<ChainId, "tezos">;
export type MultichainChainNamespace = Exclude<ChainNamespace, "tezos">;
export type MultichainChainFullId = `${MultichainChainNamespace}:${string}`;

// eip155:128123 = old Etherlink Testnet id (renamed to shadownet, handled by
// mainStore migration v12).
// eip155:5 = Ethereum Goerli, sunset by Ethereum in early 2025; Blockscout
// dropped its explorer. Handled by mainStore migration v15.
// tezos:ghostnet = discontinued Tezos testnet (replaced by shadownet). Handled
// by mainStore migration v13.
// tezos:tezlink-shadownet = Tezlink Shadownet, retired in #608 (the tezlink
// name is gone entirely; previewnet is its successor); its RPC/TzKT hosts no
// longer resolve. Handled by mainStore migration v16.
export const DEPRECATED_CHAINS = [
  "eip155:128123",
  "eip155:5",
  "tezos:ghostnet",
  "tezos:tezlink-shadownet",
] as const;
